<header *ngIf="name || hint">
	<span *ngIf="name">{{ name }}</span>
	<bas-hint *ngIf="hint" [hint]="hint" [tiny]="true"></bas-hint>
</header>